export default __webpack_public_path__ + "static/media/signin.7652b8fc.png";